import { afterHooks, beforeHooks } from "./hooks"

import ky from "ky"

export const http = ky.extend({
  throwHttpErrors: true,
  retry: 2,
  prefixUrl: "/api",
  hooks: {
    beforeRequest: [beforeHooks.setAuthHeader, beforeHooks.setAgencyHeader],
    afterResponse: [
      afterHooks.handleEmptyResponse,
      afterHooks.handleUnauthorised,
      afterHooks.handleErrors,
    ],
  },
})
export const httpRevenue = ky.extend({
  throwHttpErrors: true,
  retry: 2,
  prefixUrl: "/dashboards/api/revenue/",
  hooks: {
    beforeRequest: [beforeHooks.setAuthHeader],
    afterResponse: [
      afterHooks.handleEmptyResponse,
      afterHooks.handleUnauthorised,
      afterHooks.handleErrors,
    ],
  },
})

export const httpNoTimeout = ky.extend({
  throwHttpErrors: true,
  retry: 2,
  timeout: false,
  prefixUrl: "/api",
  hooks: {
    beforeRequest: [beforeHooks.setAuthHeader, beforeHooks.setAgencyHeader],
    afterResponse: [
      afterHooks.handleEmptyResponse,
      afterHooks.handleUnauthorised,
      afterHooks.handleErrors,
    ],
  },
})

export const libHttp = ky.extend({
  throwHttpErrors: true,
  retry: 2,
  prefixUrl: "/library",
  hooks: {
    beforeRequest: [beforeHooks.setAuthHeader],
    afterResponse: [
      afterHooks.handleEmptyResponse,
      afterHooks.handleUnauthorised,
      afterHooks.handleErrors,
    ],
  },
})

export const httpExport = ky.extend({
  throwHttpErrors: true,
  retry: 2,
  prefixUrl: "/export",
  hooks: {
    beforeRequest: [beforeHooks.setAuthHeader],
    afterResponse: [
      afterHooks.handleEmptyResponse,
      afterHooks.handleUnauthorised,
      afterHooks.handleErrors,
    ],
  },
})

export const reportGenerator = ky.extend({
  throwHttpErrors: true,
  retry: 2,
  prefixUrl: "/report-generator",
  hooks: {
    beforeRequest: [beforeHooks.setAuthHeader],
    afterResponse: [
      afterHooks.handleEmptyResponse,
      afterHooks.handleUnauthorised,
      afterHooks.handleErrors,
    ],
  },
})

export const httpMeta = ky.extend({
  throwHttpErrors: true,
  retry: 2,
  prefixUrl: "/meta",
  hooks: {
    beforeRequest: [beforeHooks.setAuthHeader],
    afterResponse: [
      afterHooks.handleEmptyResponse,
      afterHooks.handleUnauthorised,
      afterHooks.handleErrors,
    ],
  },
})
